var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgc"},[_vm._v(" "+_vm._s("毕业论文暂未开启")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }